import { z } from 'zod'

import { type AdTelemetryConfig } from '@/types/ad-telemetry'

export const AdTelemetryConfigSchema = z.object({
  ad_request_sent: z.boolean().default(false),
  ad_response_received: z.boolean().default(false),
  ad_impression: z.boolean().default(false),
})

const DISABLED_AD_TELEMETRY_CONFIG: AdTelemetryConfig = {
  ad_request_sent: false,
  ad_response_received: false,
  ad_impression: false,
}

export const parseAdTelemetryConfig = (payload: unknown): AdTelemetryConfig => {
  const result = AdTelemetryConfigSchema.safeParse(payload)

  return result.success ? result.data : DISABLED_AD_TELEMETRY_CONFIG
}
